import React__default from 'react';
import { variantMappingObj } from './types.js';
import { Wrapper, Section, Hero, HeroTitle, HeroCaption, ImageWrapper, Img, CenteredHero, CenteredHeroCaption, ResponsiveGridBox, ButtonGroupWrapper, SVG } from './styles.js';
import Box from '../../Box/Box.js';
import Spacer from '../../Spacer/Spacer.js';
import AtlasButton from '../../AtlasButton/AtlasButton.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ButtonGroup = ({
  primaryAction,
  secondaryAction,
  actionHandler,
  onSelect,
  buttonAppearance = 'primary',
  linkData,
  variant = 'default',
  parentVariant = 'NoImage'
}) => {
  const testId = `hero-btn-primary-${variantMappingObj[parentVariant]}-${buttonAppearance}`;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, linkData ? /*#__PURE__*/React__default.createElement(ButtonGroupWrapper, {
    variant: variant
  }, /*#__PURE__*/React__default.createElement(AtlasButton, _extends({
    as: "a"
  }, linkData[0], {
    "data-testid": testId,
    appearance: buttonAppearance
  }), linkData[0].label), /*#__PURE__*/React__default.createElement(AtlasButton, _extends({
    as: "a"
  }, linkData[1], {
    appearance: "subtle-link"
  }), /*#__PURE__*/React__default.createElement(Box, {
    as: "span"
  }, /*#__PURE__*/React__default.createElement(SVG, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/SVG"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17H5V7H6V5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H6V17ZM19 10.005V19H9V5H14.99V7.49C14.99 7.68698 15.0288 7.88204 15.1042 8.06402C15.1796 8.24601 15.2901 8.41137 15.4293 8.55066C15.5686 8.68995 15.734 8.80044 15.916 8.87582C16.098 8.9512 16.293 8.99 16.49 8.99H20.99V8.468C20.99 8.171 20.858 7.89 20.631 7.7L15.557 3.464C15.197 3.164 14.744 3 14.275 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.005H19Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React__default.createElement(Spacer, {
    axis: "horizontal",
    size: 4
  }), linkData[1].label)) : /*#__PURE__*/React__default.createElement(ButtonGroupWrapper, {
    variant: variant
  }, /*#__PURE__*/React__default.createElement(AtlasButton, {
    as: "a",
    href: primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.url,
    onClick: () => actionHandler ? actionHandler(primaryAction) : null,
    "data-testid": testId,
    appearance: buttonAppearance
  }, primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.label), /*#__PURE__*/React__default.createElement(AtlasButton, {
    as: "a",
    href: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.url,
    appearance: "subtle-link",
    onClick: onSelect ? onSelect : undefined
  }, /*#__PURE__*/React__default.createElement(Box, {
    as: "span"
  }, /*#__PURE__*/React__default.createElement(SVG, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/SVG"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17H5V7H6V5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H6V17ZM19 10.005V19H9V5H14.99V7.49C14.99 7.68698 15.0288 7.88204 15.1042 8.06402C15.1796 8.24601 15.2901 8.41137 15.4293 8.55066C15.5686 8.68995 15.734 8.80044 15.916 8.87582C16.098 8.9512 16.293 8.99 16.49 8.99H20.99V8.468C20.99 8.171 20.858 7.89 20.631 7.7L15.557 3.464C15.197 3.164 14.744 3 14.275 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.005H19Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React__default.createElement(Spacer, {
    axis: "horizontal",
    size: 4
  }), secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.label)));
};
const SingleButton = ({
  onSelect,
  buttonAppearance = 'subtle-link',
  singleLinkData,
  variant = 'default',
  parentVariant = 'NoImage',
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(AtlasButton, _extends({
    as: "a",
    href: singleLinkData === null || singleLinkData === void 0 ? void 0 : singleLinkData.href,
    onClick: singleLinkData ? singleLinkData.onClick : undefined,
    appearance: buttonAppearance
  }, props), /*#__PURE__*/React__default.createElement(Box, {
    as: "span"
  }, /*#__PURE__*/React__default.createElement(SVG, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/SVG"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17H5V7H6V5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H6V17ZM19 10.005V19H9V5H14.99V7.49C14.99 7.68698 15.0288 7.88204 15.1042 8.06402C15.1796 8.24601 15.2901 8.41137 15.4293 8.55066C15.5686 8.68995 15.734 8.80044 15.916 8.87582C16.098 8.9512 16.293 8.99 16.49 8.99H20.99V8.468C20.99 8.171 20.858 7.89 20.631 7.7L15.557 3.464C15.197 3.164 14.744 3 14.275 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.005H19Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React__default.createElement(Spacer, {
    axis: "horizontal",
    size: 4
  }), singleLinkData === null || singleLinkData === void 0 ? void 0 : singleLinkData.label));
};
SingleButton.displayName = "SingleButton";
// variants:
const OneLineTitle = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant,
  display = 'default',
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    "data-testid": "hero-olt"
  }, /*#__PURE__*/React__default.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React__default.createElement(Hero, null, /*#__PURE__*/React__default.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block'
    }
  }, title), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React__default.createElement(HeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), display === 'default' ? /*#__PURE__*/React__default.createElement(ButtonGroup, _extends({}, props, {
    parentVariant: variant === 'WithImage' && imgUrl ? 'WithImage' : 'NoImage'
  })) : /*#__PURE__*/React__default.createElement(SingleButton, _extends({}, props, {
    parentVariant: variant === 'WithImage' && imgUrl ? 'WithImage' : 'NoImage'
  }))), variant === 'WithImage' && imgUrl && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: 1,
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(ImageWrapper, {
    "data-testid": "hero-image-wrapper"
  }, /*#__PURE__*/React__default.createElement(Img, {
    src: imgUrl,
    alt: imgAlt,
    "data-testid": "hero-image"
  })))));
};
OneLineTitle.displayName = "OneLineTitle";
const TwoLineTitleLeft = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant,
  display = 'default',
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    "data-testid": "hero-tltl"
  }, /*#__PURE__*/React__default.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React__default.createElement(Hero, null, /*#__PURE__*/React__default.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block'
    }
  }, title), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React__default.createElement(HeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), display === 'default' ? /*#__PURE__*/React__default.createElement(ButtonGroup, _extends({}, props, {
    parentVariant: variant
  })) : /*#__PURE__*/React__default.createElement(SingleButton, _extends({}, props, {
    parentVariant: variant
  })))));
};
TwoLineTitleLeft.displayName = "TwoLineTitleLeft";
const TwoLineTitleCenter = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant = 'TwoLineTitleCenter',
  display = 'default',
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    "data-testid": "hero-tltc"
  }, /*#__PURE__*/React__default.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React__default.createElement(CenteredHero, null, /*#__PURE__*/React__default.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React__default.createElement(CenteredHeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), display === 'default' ? /*#__PURE__*/React__default.createElement(ButtonGroup, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  })) : /*#__PURE__*/React__default.createElement(SingleButton, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  })))));
};
TwoLineTitleCenter.displayName = "TwoLineTitleCenter";
const TwoColumnTitleCenter = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant = 'TwoColumnTitleCenter',
  display = 'default',
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    as: "div",
    "data-testid": "hero-2coltc"
  }, /*#__PURE__*/React__default.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React__default.createElement(ResponsiveGridBox, null, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(CenteredHero, null, /*#__PURE__*/React__default.createElement(Spacer, {
    axis: "vertical",
    size: 32
  }), /*#__PURE__*/React__default.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React__default.createElement(CenteredHeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle',
      marginTop: '0!important'
    }
  }, caption))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1
    }
  }, display === 'default' ? /*#__PURE__*/React__default.createElement(ButtonGroup, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  })) : /*#__PURE__*/React__default.createElement(SingleButton, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  }))))));
};
TwoColumnTitleCenter.displayName = "TwoColumnTitleCenter";
const VariableTwoColumnTitleCenter = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant,
  display,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, display === 'default' ? /*#__PURE__*/React__default.createElement(Wrapper, {
    as: "div",
    "data-testid": "variable-hero-standard-2coltc"
  }, /*#__PURE__*/React__default.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React__default.createElement(ResponsiveGridBox, null, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(CenteredHero, null, /*#__PURE__*/React__default.createElement(Spacer, {
    axis: "vertical",
    size: 32
  }), /*#__PURE__*/React__default.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React__default.createElement(CenteredHeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle',
      marginTop: '0!important'
    }
  }, caption))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(ButtonGroup, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  })))))) : /*#__PURE__*/React__default.createElement(Wrapper, {
    "data-testid": "variable-hero-tctc-no-cta"
  }, /*#__PURE__*/React__default.createElement(Section, {
    "data-testid": "hero-component-variable-hero"
  }, /*#__PURE__*/React__default.createElement(Hero, null, /*#__PURE__*/React__default.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block'
    }
  }, title), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: 'block',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React__default.createElement(HeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      ml: '-8px',
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(SingleButton, _extends({}, props, {
    variant: "centered",
    parentVariant: variant,
    buttonAppearance: "subtle-link"
  })))), variant === 'VariableTwoColumnTitleCenter' && imgUrl && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: 1,
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(ImageWrapper, {
    "data-testid": "hero-image-wrapper"
  }, /*#__PURE__*/React__default.createElement(Img, {
    src: imgUrl,
    alt: imgAlt,
    "data-testid": "hero-image"
  }))))));
};
const variantsObj = {
  ['WithImage']: OneLineTitle,
  ['NoImage']: OneLineTitle,
  ['TwoLineTitleLeft']: TwoLineTitleLeft,
  ['TwoLineTitleCenter']: TwoLineTitleCenter,
  ['TwoColumnTitleCenter']: TwoColumnTitleCenter,
  ['VariableTwoColumnTitleCenter']: VariableTwoColumnTitleCenter
};

/**
 * The `PageHero` component is a general purpose hero component that renders a responsive, mobile-first hero with or without an accompanying image.
 *
 * If no image URL is passed, the "NoImage" variant will be rendered.
 *
 * Every `PageHero` variant should display a `primary` and `secondary` action, but there are several layout options available.
 *
 * **Layout Variants**:
 *
 * * **"WithImage"**: Default `PageHero` configuration. Left-aligned title and a caption with action buttons aligned in a column on the left, and a large image on the right at standard laptop and desktop viewport sizes.
 * Centered with image below at mobile viewport sizes.
 *
 * * **"NoImage"**: A left-aligned title and a caption with action buttons aligned in a column on the left at standard laptop and desktop viewport sizes.
 * Centered at mobile viewport sizes.
 *
 * * **"TwoLineTitleLeft"**: A left-aligned title and a second line for the title via the `subtitle` prop, with caption and action buttons aligned in a column on the left at standard laptop and desktop viewport sizes.
 * Centered at mobile viewport sizes. Optional emphasis color can be added to `subtitle` prop.
 *
 * * **"TwoLineTitleCenter"**: A center-aligned title and subtitle, with caption and action buttons aligned in a column at all viewport sizes.
 *
 * * **"TwoColumnTitleCenter"**: A two-column hero layout with no image, a center-aligned title and subtitle, and caption and action buttons aligned in a column at all viewport sizes.
 *
 * * **"VariableTwoColumnTitleCenter"**: If `display` is set to `default`, renders a "TwoColumnTitleCenter" with a `ButtonGroup`, else renders a "WithImage" split pane hero with no CTA.
 *
 */
const PageHero = ({
  variant = 'WithImage',
  buttonAppearance = 'primary',
  ...props
}) => {
  const Component = variantsObj[variant];
  return /*#__PURE__*/React__default.createElement(Component, _extends({
    variant: variant,
    buttonAppearance: buttonAppearance
  }, props));
};
PageHero.displayName = "PageHero";
var PageHero$1 = PageHero;

export { PageHero$1 as default };
